<template>
  <v-dialog
    v-model="show"
    max-width="500"
    overlay-color="darktext"
    overlay-opacity="0.6"
    @click:outside="closeDialog"
    @keydown.enter.prevent
  >
    <v-card>
      <v-card-title />
      <v-card-text>
        <vue-cropper
          ref="cropper"
          :src="imageToCrop"
          :check-cross-origin="checkCrossOrigin"
          :check-orientation="checkOrientation"
          :aspect-ratio="aspectRatio"
          :view-mode="2"
          :auto-crop-area="1"
          data-testid="cropper"
          @ready="cropperReady"
          :width="960"
        />
      </v-card-text>
      <v-card-actions
        class="justify-center"
        style="padding: 0 24px 16px;"
      >
        <v-card
          elevation="3"
          class="pa-2"
        >
          <v-icon
            data-testid="zoom-in-icon"
            large
            class="mx-1"
            @click="zoomIn"
          >
            mdi-magnify-plus-outline
          </v-icon>
          <v-icon
            data-testid="zoom-out-icon"
            large
            class="mx-1"
            @click="zoomOut"
          >
            mdi-magnify-minus-outline
          </v-icon>
          <v-btn
            data-testid="zoom-reset-button"
            text
            dense
            class="text-none greytext--text"
            elevation="0"
            :ripple="false"
            @click="zoomReset"
          >
            {{ $t('reset') }}
          </v-btn>
        </v-card>
        <v-spacer />
        <v-card
          elevation="3"
          class="pa-2"
        >
          <v-icon
            data-testid="square-crop-icon"
            large
            :class="{'accent--text': cropType == 'square'}"
            class="mx-1"
            @click="cropType = 'square', $refs.cropper.setAspectRatio(1/1)"
          >
            mdi-crop-square
          </v-icon>
          <v-icon
            data-testid="portrait-crop-icon"
            large
            :class="{'accent--text': cropType == 'portrait'}"
            class="mx-1"
            @click="cropType = 'portrait', $refs.cropper.setAspectRatio(2/3)"
          >
            mdi-crop-portrait
          </v-icon>
          <v-icon
            data-testid="landscape-crop-icon-thin"
            large
            :class="{'accent--text': cropType == 'landscape-thin'}"
            class="mx-1 landscape-thin"
            @click="cropType = 'landscape-thin', $refs.cropper.setAspectRatio(16/4)"
          >
            mdi-crop-landscape
          </v-icon>
          <v-icon
            data-testid="landscape-crop-icon"
            large
            :class="{'accent--text': cropType == 'landscape'}"
            class="mx-1"
            @click="cropType = 'landscape', $refs.cropper.setAspectRatio(16/9)"
          >
            mdi-crop-landscape
          </v-icon>
        </v-card>
      </v-card-actions>
      <v-card-actions class="px-6">
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 mb-2 mb-md-0"
          @click="show=false"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          :disabled="imgLoaded"
          min-width="100"
          elevation="0"
          class="rounded-xxl text-none px-4"
          color="accent"
          :loading="loading"
          @click="cropImage"
        >
          {{ cropOnUpload ? $t('upload') : $t('cropImage') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  components: { 
    VueCropper
  },
  props: {
    visible: Boolean,
    imageToCrop: {
        type: String,
        default: ''
    },
    imageType: {
        type: String,
        default: ''
    },
    cropOnUpload: Boolean
  },
  data(){
    return{
      data: null,
      checkCrossOrigin: false,
      checkOrientation: false,
      aspectRatio: 1/1,
      cropType: 'square',
      imgLoaded: false,
      loading: false,
      canvasInitial: null
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
         
      },
    }
  },   
  methods: {
    async cropperReady(){
      this.canvasInitial = this.$refs.cropper.getCanvasData()
      //this.$refs.cropper.setCropBoxData({top:0, left:0})
      let canvas_img = window.document.querySelector('img.cropper-hide');
      let src = canvas_img.getAttribute('src');
      canvas_img.setAttribute('crossorigin', '*')
      let domain = (new URL(src));
      if(domain.hostname == 'objects.dc-sto1.glesys.net'){
        this.imgLoaded = true
        const loadImage = src =>
          new Promise((resolve) => {
            canvas_img.onload = () => resolve(canvas_img);
            canvas_img.setAttribute('src', src)
          });

        await loadImage(src+'&')
        this.imgLoaded = false
      }else {
        canvas_img.setAttribute('src', src)
      }   

    },
    closeDialog() {
      this.$emit('input', false);
    },

    async cropImage() {
      this.loading = true
      let canvas_img = window.document.querySelector('img.cropper-hide');
      let src = canvas_img.getAttribute('src');
      canvas_img.setAttribute('crossorigin', '*')
      let domain = (new URL(src));
      if(domain.hostname == 'objects.dc-sto1.glesys.net'){
        const loadImage = src =>
          new Promise((resolve) => {
            canvas_img.onload = () => resolve(canvas_img);
            canvas_img.setAttribute('src', src)
          });
        await loadImage(src+'&')
      }else {
        canvas_img.setAttribute('src', src)
      }
   //this.$refs.cropper.getCroppedCanvas().width = "960"
   this.$refs.cropper.width="960"
      this.$refs.cropper.getCroppedCanvas().toBlob((blob) => {
        this.$emit('crop', blob)
      },this.imageType, 0.90)    
    },
    zoomOut () {
      this.$refs.cropper.relativeZoom(-0.1);
    },
    zoomIn () {
      this.$refs.cropper.relativeZoom(0.1);
    },
    zoomReset(){
        this.$refs.cropper.setCanvasData(this.canvasInitial)
    },
  }
}
</script>
<style>
.v-icon.landscape-thin{
  height: 36px;
  width: 36px;
  background-image: url('../assets/custom_icons/bannericon.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position-y: 9px;
  
}
.v-icon.landscape-thin.accent--text{
  background-image: url('../assets/custom_icons/bannericon-blue.svg');
}
.v-icon.landscape-thin::before{
  visibility: hidden;
  content: "";
  
} 
 

</style>